export const getImageForFormat = (media, format) => {
  const foundFormat = media.formats[format];
  if (foundFormat) return foundFormat.url;
  else return media.url;
};

export const round = (number, decimals) => {
  const numberParsed = parseFloat(number);
  if (!number || isNaN(numberParsed)) return number;
  return parseFloat(numberParsed.toFixed(decimals || 2));
};
